import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Radio, RadioGroup } from '@fiverr-private/forms';
import { AppI18n } from '../../../../i18n';
import { durations, HiringDurationType, spacingForControls, useBudgetAndTimelineContext } from '../utils';

export const HiringDurationSelector = () => {
  const { setSectionContentState, sectionContentState } = useBudgetAndTimelineContext();

  const onHiringDurationChange = (selected: string) => {
    setSectionContentState({
      ...sectionContentState,
      timelineDetails: {
        ...sectionContentState.timelineDetails,
        hiringDuration: selected as HiringDurationType,
      },
    });
  };

  return (
    <Stack direction="column">
      <Stack>
        <Text size="b_md" fontWeight="semibold">
          <AppI18n k={'sections.budget_and_timeline.hiring_duration.title'} />
        </Text>
      </Stack>
      <RadioGroup
        name="duration"
        value={sectionContentState.timelineDetails?.hiringDuration}
        onChange={onHiringDurationChange}
      >
        {Object.entries(durations).map(([durationKey, durationValue]) => (
          <Radio key={durationKey} value={durationValue} className={spacingForControls}>
            <Text size="b_sm">{<AppI18n k={`sections.budget_and_timeline.hiring_duration.${durationValue}`} />}</Text>
          </Radio>
        ))}
      </RadioGroup>
    </Stack>
  );
};
